import ApiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import { OrderTypesCode } from "../../helpers/orderTypesConstants";
import { OrderHistoryPages } from "../../helpers/orderHistoryConstants";
import get from "lodash/get";
import { TRACKER_STATUS } from "../../helpers/trackOrderConstants";
import Utility from "../../helpers/utility";
import { keyMapsMutation } from "../../helpers/storeKeys";
import {
  EVENT_PRODUCT_PURCHASED,
  EVENT_ORDER_COMPLETED,
  EVENT_UNKNOWN_ORDER_STATUS,
  EVENT_ORDER_FAILED,
} from "../../helpers/analyticsEvents";
import { ORDER_TYPE } from "../../helpers/OrderStatusConstants";

export default {
  namespaced: true,
  state: {
    trackOrder: {
      tracker: {
        stage: 1,
        posEventRunnerInfo: {},
      },
      orderSummary: {
        deliveryType: OrderTypesCode.DELIVERY_CODE,
        store: {},
        deliveryAddress: {},
      },
      mapUrl: "",
    },
    popupContent: false,
    isOrderSuccessful: true,
    isOrderFailed: LocalStorageFunc.getOrderFailed() || false,
    orderId: "",
  },
  getters: {},
  mutations: {
    updateTrackOrder(state, payload) {
      state.trackOrder = { ...state.trackOrder, ...payload };
    },
    updateMapUrl(state, payload) {
      state.trackOrder = { ...state.trackOrder, ...payload };
    },
    updateOrderSummary(state, payload) {
      state.orderSummary = payload;
    },
    updateIsOrderSuccessful(state, payload) {
      state.isOrderSuccessful = payload;
    },
    updateIsOrderFailed(state, payload) {
      LocalStorageFunc.setOrderFailed(payload);
      state.isOrderFailed = payload;
    },
    updateOrderId(state, payload) {
      if (state.orderId != payload && state.isOrderFailed) {
        LocalStorageFunc.setOrderFailed(false);
        state.isOrderFailed = false;
      }
      LocalStorageFunc.setOrderId(payload);
      state.orderId = payload;
    },
  },
  actions: {
    getTrackOrder({ commit, dispatch }, payload) {
      // commit("updateNotificationData", InlineNotificationData?.data);
      ApiCalls.TRACK_ORDER_API({
        headers: Headers({ withMobileNo: true }),
        // @todo send correct payload
        //payload: LocalStorageFunc.storeId(),
        payload: payload,
      })
        .then(function (response) {
          switch (get(response?.data, "tracker.stage", false)) {
            case TRACKER_STATUS.CONFIRMED:
            case TRACKER_STATUS.BEING_BAKED:
            case TRACKER_STATUS.DISPATCHED:
              commit("updateTrackOrder", response?.data);
              if (Utility.isCurrentlyAtUrl("/order-tracking")) {
                // call after .5 min
                setTimeout(() => {
                  dispatch("getTrackOrder", payload);
                }, 30000);
              } else {
                // To Do: handle negative case when succesive api hit doesn't give any thing
                // after multiple hit send unknown response
              }
              break;
            case TRACKER_STATUS.CANCELLED:
              commit("updateTrackOrder", response?.data);
              if (Utility.isCurrentlyAtUrl("/order-tracking")) {
                commit("updateIsOrderFailed", true);

                // redirects to previous order detail page
                LocalStorageFunc.setOrderHistoryPage(
                  OrderHistoryPages.PREVIOUS_ORDERS_DETAIL
                );
                Utility.sendToOrderHistory();
              } else {
                // To Do: handle negative case when succesive api hit doesn't give any thing
                // after multiple hit send unknown response
              }
              break;
            case TRACKER_STATUS.DELIVERED:
              commit("updateTrackOrder", response?.data);
              // yield put(saveTrackOrder(response));
              // yield put(showChessyRewardConfetti({ showChessyRewardConfetti: true }));
              // callback?.(response);
              break;
            default:
              commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
                root: true,
              });
              // if (response.status === RESPONSE.FAILED) {
              //   const content = {
              //     message:
              //       get(response, 'errors[0].displayMsg', false) ||
              //       common.internalServerError,
              //     headerText: get(response, 'errors[0].header', false) || common.ops,
              //     rightCTAText: get(response, 'errors[0].btnMsg', false) || common.ok
              //   };
              //   callback?.(response);
              //   yield put(showPopup(content));
              // }
              break;
          }
          if (get(response?.data, "tracker.trackOnMap", false)) {
            let orderSummary = response?.data?.orderSummary;
            dispatch("trackOnMap", {
              storeId: orderSummary?.store?.id,
              order: orderSummary?.store?.orderId,
              orderTime: orderSummary?.store?.orderDate,
            });
          }
        })
        .catch(function (error) {
          commit("updateTrackOrder", {});
          console.log("error", error);
        });
    },
    trackOnMap({ commit, dispatch }, payload) {
      ApiCalls.TRACK_ON_MAP({
        headers: Headers({ withMobileNo: true, withAuthorizationKey: true }),
        //payload: LocalStorageFunc.storeId(),
        //@todo map payload accordingly
        payload: {
          storeId: payload.storeId,
          order: payload.order,
          orderTime: payload.orderTime,
          userId: LocalStorageFunc.getUserId(),
        },
      })
        .then(function (response) {
          if (response?.data) {
            commit("updateMapUrl", { mapUrl: response?.data?.map_url });
          }
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    cancelOrderApi({ commit }, payload) {
      ApiCalls.CANCEL_ORDER_API({
        headers: Headers(),
        payload: {
          //@todo:- add payload accordingly
        },
      })
        .then(function (response) {})
        .catch(function (error) {});
    },
    postSubmitTrackOrder({ commit, state, dispatch }, payload) {
      ApiCalls.POST_SUBMIT_TRACK_ORDER_API({
        headers: Headers({ withMobileNo: true }),
        payload: payload,
      })
        .then(function (response) {
          setTimeout(() => {
            if (response?.data?.status == "WAIT") {
              commit("updateIsOrderFailed", true);
              Utility.sendToOrderTracking(
                LocalStorageFunc.getOrderTransactionId()
              );
              EVENT_ORDER_FAILED();
            }
          }, 30000);
          if (response?.data?.status == "SUCCESS") {
            commit("updateIsOrderFailed", false);
            LocalStorageFunc.setOrderSummary(response?.data?.orderSummary);
            commit("updateTrackOrder", {
              orderSummary: response?.data?.orderSummary,
            });
            commit("updateIsOrderSuccessful", true);
            commit("updateOrderId", response?.data?.orderSummary?.id);
            dispatch("getTrackOrder", {
              mobile:
                response?.data?.orderSummary?.deliveryPhoneNumber ||
                LocalStorageFunc.getUserMobileNo(),
              order: response?.data?.orderSummary?.store?.orderId,
            });
            commit(keyMapsMutation.UPDATE_SHOW_THANK_YOU_MODAL, true, {
              root: true,
            });
            if (response?.data?.orderSummary?.advanceOrder) {
              LocalStorageFunc.setOrderHistoryPage(
                OrderHistoryPages.ADVANCED_ORDER_DETAIL
              );
            }
            let orderSummary = response?.data?.orderSummary;
            let analyticKeyValuesFromOrderSummary =
              Utility.getAnalyticKeyValuesFromOrderSummary(orderSummary);
            EVENT_ORDER_COMPLETED({
              ...analyticKeyValuesFromOrderSummary,
              paymentSummary: orderSummary?.paymentSummary,
              cartId: orderSummary?.cartId,
              orderId: orderSummary?.store?.orderId,
              deliveryOrderTypeSummary: orderSummary?.deliveryOrderType,
              deliveryType: orderSummary?.deliveryType,
            });
            const { itemName, itemSku, quantity, subTotal, dataSummary } =
              analyticKeyValuesFromOrderSummary;

            itemName.map((itemN, index) => {
              EVENT_PRODUCT_PURCHASED({
                itemName: itemN,
                itemSku: itemSku[index],
                quantity: quantity[index],
                subTotal: subTotal[index],
                ...dataSummary,
                paymentSummary: orderSummary?.paymentSummary,
                cartId: orderSummary?.cartId,
                orderId: orderSummary?.store?.orderId,
                deliveryOrderTypeSummary: orderSummary?.deliveryOrderType,
                deliveryType: orderSummary?.deliveryType,
              });
            });
          } else if (response?.data?.status == "WAIT" && !state.isOrderFailed) {
            EVENT_UNKNOWN_ORDER_STATUS();
            setTimeout(() => {
              dispatch("postSubmitTrackOrder", {
                transactionId: payload.transactionId,
              });
            }, 1000);
          } else if (response?.data?.status == "FAILED") {
            LocalStorageFunc.setOrderSummary(response?.data?.orderSummary);
            commit("updateTrackOrder", {
              orderSummary: response?.data?.orderSummary,
            });
            commit("updateIsOrderSuccessful", false);
            commit("updateIsOrderFailed", true);
            commit("updateOrderId", response?.data?.orderFailure?.orderId);
            Utility.sendToOrderTracking();
            EVENT_ORDER_FAILED();
          }
          // reseting ordertype to delivery if orderType is not delivery
          if (
            LocalStorageFunc.getSelectedDeliveryType() !== ORDER_TYPE.DELIVERY
          ) {
            LocalStorageFunc.resetAllSelectedLocations();
            LocalStorageFunc.setDeliveryType("D");
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
          console.log("error", error);
        });
    },
  },
};
